export class CaseInformation{
  hasAppliedForSocialSecurity:string = '';
  caseLevel:string = '';
  onsetDate:Date = null;
  householdIncome:string = '';
  disabilityDescription:string = '';
  medications:string = '';
}
